export default {
  AvailableStartTime: 'Available StartTime',
  AvailableStartTimeMin: 'Available StartTime Min',
  AvailableStartTimeMax: 'Available StartTime Max',
  AvailableExpireTime: 'Available ExpireTime',
  AvailableExpireTimeMin: 'Available ExpireTime Min',
  AvailableExpireTimeMax: 'Available ExpireTime Max',
  CompanyDiscountAmount: 'Courier Discount Amount',
  CompanyDiscountAmountMin: 'Courier Discount Amount Min',
  CompanyDiscountAmountMax: 'Courier Discount Amount Max',
  CompanyDiscountTypeId: 'CompanyDiscount Type',
  DeadlineTime: 'DeadlineTime',
  DeadlineTimeMin: 'DeadlineTime Min',
  DeadlineTimeMax: 'DeadlineTime Max',
  MarketplaceDiscountType: 'MarketplaceDiscount type',
  MarketplaceDiscountAmount: 'Marketplace Discount Amount',
  MarketplaceDiscountAmountMin: 'Marketplace Discount Amount Min',
  MarketplaceDiscountAmountMax: 'Marketplace Discount Amount Max',
  MarketplaceDiscountTypeId: 'MarketplaceDiscount Type',
  MinimumMarketplaceDiscount: 'Minimum Marketplace Discount',
  MaximumMarketplaceDiscount: 'Maximum Marketplace Discount',
  MaximumMarketplaceDiscountAmountMin: 'Maximum Marketplace Discount Min',
  MaximumMarketplaceDiscountAmountMax: 'Maximum Marketplace Discount Max',
  MinimumCompanyDiscount: 'Minimum Courier Discount',
  MinimumCompanyDiscountAmountMin: 'Minimum Courier Discount Amount Min',
  MinimumCompanyDiscountAmountMax: 'Minimum Courier Discount Amount Max',
  MinimumCompanyDiscountMin: 'Minimum Courier Discount Min',
  MinimumCompanyDiscountMax: 'Minimum Courier Discount Max',
  MaximumCompanyDiscount: 'Minimum Courier Discount',
  MaximumCompanyDiscountMin: 'Minimum Courier Discount Min',
  MaximumCompanyDiscountMax: 'Minimum Courier Discount Max',
  Percent: 'Percent',
  StateId: 'State',
  Scope: 'Scope',
  Title: 'Title'
}
